import PropTypes from 'prop-types';
import styles from './trustedBadgeFooter.module.scss';
import TrustedBadge from '../trustedBadge/trustedBadge';

export default function TrustedBadgeFooter({ trustedBadge = {} }) {
  return (
    <div className={styles.trustedBadgeFooter}>
      <div className={styles.container}>
        <div className={`${styles.trustedBagdeSection} ${styles.border}`}>
          <TrustedBadge {...trustedBadge} />
        </div>
      </div>
    </div>
  );
}

TrustedBadgeFooter.propTypes = {
  trustedBadge: PropTypes.object,
};
